/**
 * GA4 Analytics Service for Campervan Bookings
 * Sends e-commerce events to populate GA4 checkout journey and sales reports.
 */
import ReactGA from 'react-ga4';

/**
 * Track when user starts checkout (Step 1)
 */
export const trackBeginCheckout = (bookingData) => {
  try {
    const value = parseFloat(bookingData?.totalPrice) || 0;

    ReactGA.event('begin_checkout', {
      currency: 'EUR',
      value: value,
      items: [{
        item_id: bookingData?.vehicleId?.toString() || 'campervan',
        item_name: bookingData?.vanTitle || 'Campervan Rental',
        item_category: 'Rental',
        price: parseFloat(bookingData?.basePrice) || 0,
        quantity: parseInt(bookingData?.nights, 10) || 1,
      }],
    });

    console.log('GA4: begin_checkout', { value });
  } catch (error) {
    console.warn('GA4 tracking failed:', error);
  }
};

/**
 * Track when user selects insurance/addons (Step 2/3)
 */
export const trackAddPaymentInfo = (bookingData, totalValue) => {
  try {
    const value = parseFloat(totalValue) || parseFloat(bookingData?.totalPrice) || 0;

    ReactGA.event('add_payment_info', {
      currency: 'EUR',
      value: value,
      items: [{
        item_id: bookingData?.vehicleId?.toString() || 'campervan',
        item_name: bookingData?.vanTitle || 'Campervan Rental',
        item_category: 'Rental',
        price: parseFloat(bookingData?.basePrice) || 0,
        quantity: parseInt(bookingData?.nights, 10) || 1,
      }],
    });

    console.log('GA4: add_payment_info', { value });
  } catch (error) {
    console.warn('GA4 tracking failed:', error);
  }
};

/**
 * Track successful purchase/booking
 */
export const trackPurchase = (purchaseData) => {
  try {
    const value = parseFloat(purchaseData?.totalPrice) || 0;

    ReactGA.event('purchase', {
      transaction_id: purchaseData?.orderId || `booking_${Date.now()}`,
      currency: 'EUR',
      value: value,
      items: [{
        item_id: purchaseData?.vehicleId?.toString() || 'campervan',
        item_name: purchaseData?.vanTitle || 'Campervan Rental',
        item_category: 'Rental',
        price: parseFloat(purchaseData?.basePrice) || 0,
        quantity: parseInt(purchaseData?.nights, 10) || 1,
      }],
    });

    console.log('GA4: purchase', { transaction_id: purchaseData?.orderId, value });
  } catch (error) {
    console.warn('GA4 tracking failed:', error);
  }
};

/**
 * Track when user views a campervan
 */
export const trackViewItem = (vehicleData) => {
  try {
    ReactGA.event('view_item', {
      currency: 'EUR',
      value: parseFloat(vehicleData?.dailyRate) || 0,
      items: [{
        item_id: vehicleData?.id?.toString() || 'campervan',
        item_name: vehicleData?.name || 'Campervan',
        item_category: 'Rental',
        price: parseFloat(vehicleData?.dailyRate) || 0,
      }],
    });
  } catch (error) {
    console.warn('GA4 tracking failed:', error);
  }
};

/**
 * Track when user selects dates (add to cart equivalent)
 */
export const trackAddToCart = (bookingData) => {
  try {
    const value = parseFloat(bookingData?.totalPrice) || 0;

    ReactGA.event('add_to_cart', {
      currency: 'EUR',
      value: value,
      items: [{
        item_id: bookingData?.vehicleId?.toString() || 'campervan',
        item_name: bookingData?.vanTitle || 'Campervan Rental',
        item_category: 'Rental',
        price: parseFloat(bookingData?.basePrice) || 0,
        quantity: parseInt(bookingData?.nights, 10) || 1,
      }],
    });

    console.log('GA4: add_to_cart', { value });
  } catch (error) {
    console.warn('GA4 tracking failed:', error);
  }
};
